import Attachment from "./attachment"
import CollectionProto from "../../data-structures/depricated/collection-proto"
// @ts-ignore
import TextEditorUtils from "../../gd-components/rich-editor/utils/utils"
import {AttachmentNode} from "../../gd-components/editor/plugins/attachment/node/node"

const debug = false
// const debug = "AttachmentsCollection"

export default class AttachmentsCollection extends CollectionProto<Attachment> {

    constructor(models?:any[]) {
        super(models, Attachment);
    }

    get withPreview() {
        return _.filter(this._models, attachment=>attachment.previewAvailable)
    }

    get withPreviewAndNotInMessage() {
        return _.filter(this._models, attachment=>attachment.previewAvailable && !attachment.inMessageRTF)
    }

    get withoutPreviewAndNotInMessage() {
        return _.filter(this._models, attachment=>!attachment.previewAvailable && !attachment.inMessageRTF)
    }

    get attachmentsNotInMessagesTotal() {
        return _.size(_.filter(this._models, attachment=>!attachment.inMessageRTF))
    }

    // For attachments
    get allAttachments() {
        return this._models
    }

    // For single attachment
    get singleAttachment() {

        if(!this._models[0]){
            return null
        }

        return this._models[0]
    }

    // true if all files save - else false
    get allFilesSaved() {
        let result = true
        _.map(this._models, attachment=>{
            if (!attachment.isSaved) result = false
        })
        return result
    }

    get hasUploadsInProgress() {
        let result = false;
        _.map(this._models, attachment => {
            if (!attachment.isUploadDone) result = true
        })
        return result
    }

    markAllAsSaved() {
        _.map(this._models, attachment=>{
            attachment.isSaved = true
        })
    }

    // @ts-ignore
    remove(attachment:Attachment):void {
        super.remove(attachment.id)
    }

    _applyAttachmentsInMessage = (attachmentsInMessage: ID[]) => {
        let hasChanged = false

        // firstly let's mark added to editor
        _.map(attachmentsInMessage, fileId=>{
            const attachment = this.get(fileId)

            if (!attachment) {
                console.warn("#99dkd strange ... no attachment but it is in message...")
                return
            }

            if (attachment.inMessageRTF === false) {
                attachment.inMessageRTF = true
                hasChanged = true
            }
        })

        // now lets mark removed ?
        _.forEach(this._models, attachment=>{
            if (attachment.inMessageRTF && !attachmentsInMessage.includes(attachment.fileId)) {
                attachment.inMessageRTF = false
                hasChanged = true
            }
        })

        return hasChanged
    }

    applyMessageRTF(messageRTF:any) {
        debug && console.log(debug, 'applyMessageRTF', messageRTF)

        // array of fileId
        let attachmentsInMessage
        if (!messageRTF?.v) {       // old format
            attachmentsInMessage = TextEditorUtils.attachmentsInMessage(messageRTF)
        } else if (messageRTF?.v && messageRTF.content) { // new (Lexical) format
            attachmentsInMessage = TextEditorUtils.attachmentsInLexicalMessage(messageRTF.content)
        }

        debug && console.log(debug, 'applyMessageRTF attachmentsInMessage', attachmentsInMessage)

        return this._applyAttachmentsInMessage(attachmentsInMessage)
    }

    toJSON() {
        if (this.isEmpty) return null;

        const readyToExport = _.filter(this._models, attachment=>{
            return !attachment.isNewUpload || (attachment.isNewUpload && attachment.dropzoneUploadDone)
        })

        return _.map(readyToExport, (attachment:Attachment)=>attachment.toJSON())
    }

    // set company to all models - used in support tickets where attachments are form diff company
    setCompany(companyId:ID) {
        this.models.map((attachment:Attachment)=>{
            attachment.companyId = companyId
        })
    }

}
